// extracted by mini-css-extract-plugin
module.exports = {"slide":"MOSlide_slide__1ndCj","img":"MOSlide_img__1PZFa","title":"MOSlide_title__JBAWx","text":"MOSlide_text__2lo4b"};